import {
  FETCH_PARTICIPANTS_DATA_ASYNC,
  GET_GROUP_AUTONOMOUS_CONFIG_MEMBER_ASYNC,
  UPDATE_PARTICIPANTS_NUMBERS_ASYNC,
} from './constants'

export const getGroupAutonomousConfigMemberSuccess = (data) => ({
  type: GET_GROUP_AUTONOMOUS_CONFIG_MEMBER_ASYNC.SUCCESS,
  payload: { data },
})
export const getGroupAutonomousConfigMemberError = (error) => ({
  type: GET_GROUP_AUTONOMOUS_CONFIG_MEMBER_ASYNC.ERROR,
  error,
})

export const updateParticipantsNumbersSuccess = (data) => ({
  type: UPDATE_PARTICIPANTS_NUMBERS_ASYNC.SUCCESS,
  payload: { data },
})
export const updateParticipantsNumbersError = (error) => ({
  type: UPDATE_PARTICIPANTS_NUMBERS_ASYNC.ERROR,
  error,
})

export const fetchParticipantsData = (data) => ({
  type: FETCH_PARTICIPANTS_DATA_ASYNC.INITIATE,
  payload: { data },
})

export default {
  // to props
  fetchParticipantsData,
}
